import { FunctionComponent, PropsWithChildren } from 'react';

type AlertType = 'warning' | 'success' | 'danger';
type AlertSize = 'base' | 'sm' | 'md' | 'lg';

type Props = PropsWithChildren<{
    type: AlertType;
    size?: AlertSize;
    className?: string;
}>;

const bgColors = {
    warning: 'bg-secondary',
    success: 'bg-primary',
    danger: 'bg-red-700',
};

const textColors = {
    warning: 'text-dark-green',
    success: 'text-light-grey',
    danger: 'text-light-grey',
};

const textSizes = {
    lg: 'text-lg',
    md: 'text-md',
    sm: 'text-sm',
    base: 'text-base',
};

const Alert: FunctionComponent<Props> = ({ type, size = 'base', children, className, ...rest }) => {
    return (
        <div
            {...rest}
            className={`rounded-md border border-transparent ${bgColors[type]} mb-3 p-3 ${
                textSizes[size]
            } font-medium ${textColors[type]} ${className || ''}`}
            role="alert">
            {children}
        </div>
    );
};

Alert.displayName = 'Alert';

export default Alert;
